import router from '@/router'

const catchUnauthorizedError = () => {
  localStorage.removeItem('token')
  router.push({ name: 'login' })
}

export default catchUnauthorizedError
